import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode } from 'react'

type Direction = 'forward' | 'back'

interface IProps {
  viewKey: string | number
  direction?: Direction
  className?: string
  children: ReactNode
}

export const SitePageTransition = ({ viewKey, direction = 'forward', className, children }: IProps) => {
  const dir = direction === 'back' ? -1 : 1

  return (
    <div className={className} style={{ position: 'relative' }}>
      <AnimatePresence mode='wait'>
        <motion.div
          key={viewKey}
          style={{ width: '100%' }}
          initial={{ opacity: 0, x: 24 * dir }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -24 * dir }}
          transition={{ duration: 0.22, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
